import { useState } from 'react';
import { sendEvent, useEventNotification } from '../../features/visual-analytics/hooks/events';
import { ModalPortal } from '../modal-portal/ModalPortal';

const MSGPdfViewer = 'showPdfViewer';

interface TpPdfViewerData {
  pdfUrl: string;
  callBackOK: any;
  callBackCancel: any;
}

export function promptPdfViewer(pdfUrl: string) {
  return new Promise((resolve, reject) => {
    function callBackOK() {
      resolve(true);
    }

    function callBackCancel() {
      reject();
    }

    const pdfDataData: TpPdfViewerData = {
      pdfUrl,
      callBackOK,
      callBackCancel,
    };
    sendEvent(MSGPdfViewer, pdfDataData);
  });
}

export function PdfViewer() {
  const [pdfData, setPdfData] = useState<TpPdfViewerData | null>(null);

  useEventNotification(
    MSGPdfViewer,
    (tpe: string, contentInput: TpPdfViewerData) => {
      setPdfData(contentInput);
    },
    [],
  );

  if (!pdfData) return null;

  // Parameters:
  // toolbar=1  -> Show the browser's native print/download bar
  // view=FitH  -> Fit the PDF to the width of the iframe
  // navpanes=0 -> Hide the left-hand thumbnail/bookmark sidebar
  const viewerParams = '#toolbar=1&view=FitH&navpanes=0';
  const fullSrc = `${pdfData.pdfUrl}${viewerParams}`;

  return (
    <ModalPortal
      keepBlur={true}
      close={() => {
        setPdfData(null);
      }}
    >
      <div style={{ height: '90vh', width: '1200px' }}>
        <iframe
          src={fullSrc}
          title="PDF Viewer"
          width="100%"
          height="100%"
          // SECURITY SETTINGS
          // 1. Prevent the iframe from knowing the parent URL
          referrerPolicy="no-referrer"
          style={{ border: 'none' }}
        />
      </div>
    </ModalPortal>
  );
}
